import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3208, { U3208ROLES } from './U3208';
import U3208AiRagCorpusList from './components/U3208AiRagCorpusList';
import U3208AiRagCorpusForm from './components/U3208AiRagCorpusForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3208Routes: RouteObject[] = [
  {
    path: 'U3208',
    element: <U2000RequireRole allowedRoles={[U3208ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3208 />,
        children: [
          { index: true, element: <U3208AiRagCorpusList /> },
          { path: ':id', element: <U3208AiRagCorpusForm /> },
        ],
      },
    ],
  },
];

export default U3208Routes;
